import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';
import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
import 'mutationobserver-shim';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Tooltip from 'primevue/tooltip';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import App from './App';
import router from './router';
import './assets/tailwind.css';

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});

createApp(App)
  .use(router)
  .use(pinia)
  .use(PrimeVue, {
    theme: {
      preset: MyPreset,
      options: {
        darkModeSelector: false || 'none',
      },
    },
  })
  .directive('tooltip', Tooltip)
  .mount('#app');
